// import React from "react";

// import {
//   Button,
//   Content,
//   Flex,
//   FlexItem,
// } from "@patternfly/react-core";

// import { NavLink } from "react-router-dom";

// import "./MegaMenuFooter.css";

// const MegaMenuFooter = ({ menu }) => {
//   const footer = menu.footer;

//   if (!footer) {
//     return null;
//   }

//   return (
//     <div className="school-mega-menu-footer">
//       <Flex
//         justifyContent={{ default: "justifyContentSpaceBetween" }}
//         alignItems={{ default: "alignItemsCenter" }}
//       >
//         <FlexItem>
//           {footer.title && (
//             <Content component="h3">{footer.title}</Content>
//           )}

//           {footer.description && (
//             <Content component="p">{footer.description}</Content>
//           )}
//         </FlexItem>

//         {footer.action && (
//           <FlexItem>
//             <Button
//               variant="stateful"
//               component={(props) => (
//                 <NavLink {...props} to={footer.action.to} />
//               )}
//             >
//               {footer.action.label}
//             </Button>
//           </FlexItem>
//         )}
//       </Flex>
//     </div>
//   );
// };

// export default MegaMenuFooter;
import React from "react";

import {
  Button,
  Content,
  Flex,
  FlexItem,
} from "@patternfly/react-core";

import { NavLink } from "react-router-dom";

import useNavigation from "../../hooks/useNavigation";

import "./MegaMenuFooter.css";

const MegaMenuFooter = ({ menu }) => {
  const { closeMegaMenu } = useNavigation();

  const footer = menu.footer;

  if (!footer) {
    return null;
  }

  return (
    <div className="school-mega-menu-footer">
      <Flex
        justifyContent={{ default: "justifyContentSpaceBetween" }}
        alignItems={{ default: "alignItemsCenter" }}
      >
        <FlexItem>
          {footer.title && (
            <Content component="h3">{footer.title}</Content>
          )}

          {footer.description && (
            <Content component="p">{footer.description}</Content>
          )}
        </FlexItem>

        {footer.action && (
          <FlexItem>
            <Button
              variant="stateful"
              component={(props) => (
                <NavLink
                  {...props}
                  to={footer.action.to}
                  onClick={closeMegaMenu}
                />
              )}
            >
              {footer.action.label}
            </Button>
          </FlexItem>
        )}
      </Flex>
    </div>
  );
};

export default MegaMenuFooter;